export default "__VITE_ASSET__n3nfXGYR__"